(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Components/Modal", [], factory);
	else if(typeof exports === 'object')
		exports["Components/Modal"] = factory();
	else
		root["NextcloudVue"] = root["NextcloudVue"] || {}, root["NextcloudVue"]["Components/Modal"] = factory();
})(window, function() {
return 